export default {
  loginFailed: "登录失败，请再尝试。",
  requestFailed: "请求失败，请检查您的互联网连接。",
  invalidLogin: "无效的用户名或密码。",
  invalidPassword: "无效的用户名或密码。",
  thisFunctionExists: "此功能已存在。",
  thisFunctionNotAllowDelete: "此功能不允许删除。",
  thisFunctionNotExists: "此功能不存在。",
  targetFunctionIdRequired: "目标功能ID不能为空。",
  thisPageExists: "此页面已存在。",
  thisPageNotAllowDelete: "此页面不允许删除。",
  thisRoleExists: "此角色已存在。",
  thisRoleExist: "此角色已存在",
  thisRoleNotAllowDelete: "此角色不允许删除。",
  targetRoleIdRequired: "目标角色ID不能为空",
  systemError: "系统无法处理您的请求。",
  actionbyRequired: "当前用户登录ID不能为空。",
  sessionTokenRequired: "Session Token 不能为空。",
  functionIdRequired: "功能ID不能为空。",
  functionNameRequired: "功能名称不能为空。",
  newFunctionNameRequired: "新功能名称不能为空。",
  pageIdRequired: "页面ID不能为空。",
  newPageIdRequired: "新页面不能为空 （添加页面）。",
  newPageNameRequired: "新页面名称不能为空 （添加页面/编辑页面）。",
  targetPageIdRequired: "页面ID （删除页面/获取页面角色列表/设置页面角色/编辑页面）。",
  userIdRequired: "用户ID不能为空。",
  passwordRequired: "密码不能为空。",
  userNameRequired: "用户名不能为空。",
  passwordValidation: "密码必须是6-20个字符以及数字和字母的组合。",
  pageNumRequired: "页码。",
  pageSizeRequired: "页面大小（行）。",
  roleIdRequired: "角色ID不能为空。",
  oldPasswordRequired: "当前密码不能为空。",
  userStatusRequired: "用户状态不能为空。",
  newRoleIdRequired: "新角色不能为空 （添加角色）。",
  newRoleNameRequired: "新角色名称不能为空 （添加角色/编辑角色）。",
  startDateRequired: "开始日期不能为空。",
  endDateRequired: "结束日期不能为空。",
  startDateIsGteEndDate: "开始日期大于结束日期。",
  sportsTypeRequired: "运动类型不能为空。",
  teamTypeRequired: "团队类型不能为空。",
  thisRoleNotExists: "此角色不存在。",
  thisPageNotExists: "此页面不存在。",
  thisUserExists: "此用户ID已存在。",
  thisUserNotExists: "此用户ID不存在。",
  thisUserBlackListed: "此用户已被列入黑名单。",
  thisUserInactive: "此用户冻结。",
  thisUserBlocked: "此用户已被阻塞。",
  thisUserNotActive: "此用户未激活。",
  invalidUser: "无效的用户。",
  NoUserAccessRight: "该用户无权访问此页面。",
  unableSPProcess: "系统无法处理您的请求。",
  connection: "连接错误",

  isRequired: "请输入{fname}",
  isMinValue: "{fname}必须至少为{fvalue}。",
  isMaxValue: "{fname}必须小于或等于{fvalue}。",
  isMinLength: "{fname}必须至少包含{fvalue}个字符。",
  isMaxLength: "{fname}必须小于或等于{fvalue}个字符。",
  isAlpha: "{fname}必须是字母。",
  isAlphaNum: "{fname}必须是字母数字。",
  isNumeric: "{fname}必须是数字。",
  isEmail: "{fname}必须是有效的电子邮件地址。",
  isIpAddress: "{fname}必须是有效的IPv4地址。",
  isSameAs: "{fname}必须与{fname2}相同。",
  isUrl: "{fname} 仅接受网址。",
  containAlphaNum: "{fname}必须至少有一个数字和一个字母。",
  selectOption: "请选择{fname}",
  notSameAs: "{fname}和{fname2}不能一样。",
  isBetween: "{fname}必须介于{min}和{max}之间。",
  isSSFormat: "超资深代理账号ID格式不符合。",
  isReserved: "备用账号。",
  isExisted: "账号已存在。",
  onlySmallCapsAlphaNum: "只允许从a到z的小写字母和0到9。",

  system_error: "系统无法处理您的请求。",
  invalid_password: "无效的用户名或密码。",
  block: "您的账号已被封锁。",
  invalid_security_code: "无效的安全码。",

  source_account_id_required: "账号ID不能为空。",
  target_account_id_required: "目标账号ID不能为空。",
  permission_denied: "不允许任何权限。",
  account_id_required: "账号ID不能为空。",
  sub_login_id_required: "登入ID不能为空。",
  account_not_exists: "此账号不存在。",
  profile_not_exists: "此资料不存在。",
  account_inactive: "无效的账号。",
  not_blocked_account: "有效账号。",
  password_required: "密码不能为空。",
  parent_id_required: "主级ID不能为空。",
  parent_not_exists: "主级ID不存在。",
  invalid_account_type: "无效的账号类型。",
  account_exists: "账号已存在。",
  login_id_required: "登入ID不能为空。",
  new_login_id_required: "新登入ID不能为空。",
  login_id_not_exists: "登入ID不存在。",
  invalid_authority_role: "无效的角色。",
  profile_inactive: "无效的资料。",
  secondary_account_exists: "辅助账号已存在。",
  new_login_id_exists: "新登入ID已存在。",
  new_password_required: "新密码不能为空。",
  security_tag_required: "安全标签不能为空。",
  security_code_required: "安全码不能为空。",
  start_date_required: "开始日期不能为空。",
  end_date_required: "结束日期不能为空。",
  start_date_gt_end_date: "开始日期大于结束日期。",
  member_id_required: "会员ID不能为空。",
  currency_code_required: "货币代码不能为空。",
  commission_setting_not_exists: "佣金设置不存在。",
  incomplete_account_line: "未完整的账号行列。",
  invalid_hdp_package: "让球配套无效。",
  search_id_required: "搜索ID不能为空。",
  profile_id_required: "资料ID不能为空。",
  login_not_exists: "登入不存在。",
  no_changes: "未检测到任何更改资料。",
  start_date_require: "开始日期不能为空。",
  league_id_required: "联赛ID不能为空。",
  sport_type_required: "运动类型不能为空。",
  match_id_required: "赛事ID不能为空。",
  target_login_id_required: "目标登录ID不能为空。",
  parent_account_not_exists: "主级账号不能为空。",
  parent_account_inactive: "无效的主级账号。",
  parent_profile_not_exists: "主级资料不存在。",
  parent_profile_inactive: "无效的主级资料。",
  target_login_id_not_exists: "目标登录ID不存在。",
  incorrect_parent: "主级ID无效。",
  invalid_session: "时域请求无效。",
  session_expired: "时域已过期。",
  settle_amount_required: "结算金额不能为空。",
  invalid_settle_amount: "结算金额无效。",
  settle_amount_gt_yesterday_balance: "结算金额大于昨天余额。",
  invalid_account_status: "账号状态无效。",
  bet_limit_packages_required: "投注限额配套不能为空。",
  bet_limit_exists: "投注限额已存在。",
  member_bet_limit_package_gt_one: "会员投注限额多于一。",
  parent_bet_limit_not_exists: "主级投注限额不存在。",
  account_commission_required: "账号佣金不能为空。",
  commission_setting_exists: "佣金设置已存在。",
  parent_comm_not_exists: "主级佣金设置不存在。",
  exceeded_parent_comm: "超出了主级佣金设置。",
  others_commission_required: "其他佣金设置不能为空。",
  exceeded_parent_1x2: "超出主级的1x2佣金设置。",
  exceeded_parent_other: "超出主级其他佣金设置。",
  hdp_commission_required: "HDP（让球）佣金设置不能为空。",
  exceeded_parent_hdp_a: "超出主级HPD（A）佣金设置。",
  exceeded_parent_hdp_b: "超出主级HPD（B）佣金设置。",
  exceeded_parent_hdp_c: "超出主级HPD（C）佣金设置。",
  exceeded_parent_hdp_d: "超出主级HPD（D）佣金设置。",
  exceeded_parent_hdp_e: "超出主级HPD（E）佣金设置。",
  exceeded_parent_hdp_f: "超出主级HPD（F）佣金设置。",
  exceeded_parent_hdp_g: "超出主级HPD（G）佣金设置。",
  exceeded_parent_hdp_h: "超出主级HPD（H）佣金设置。",
  exceeded_parent_hdp_i: "超出主级HPD（I）佣金设置。",
  exceeded_parent_hdp_j: "超出主级HPD（J）佣金设置。",
  LIVECASINO_upline_pt_required: "[Livecasino] 上线PT（持仓）设置不能为空。",
  LIVECASINO_pt_setting_exists: "[真人娱乐场] PT（持仓）设置不能为空。",
  LIVECASINO_parent_pt_not_exists: "[真人娱乐场] 主级PT（持仓）设置不存在。",
  LIVECASINO_parent_min_not_meet: "[真人娱乐场] 与主级最低PT（持仓）不相符。",
  LIVECASINO_exceeded_parent_pt: "[真人娱乐场] 超出主级PT（持仓）设置。",
  LIVECASINO_account_pt_required: "[真人娱乐场] 账号PT（持仓）不能为空。",
  LIVECASINO_upline_remaining_required: "[真人娱乐场] 上线保留PT（持仓）设置不能为空。",
  LIVECASINO_account_min_required: "[真人娱乐场] 账号最低PT（持仓）设置不能为空。",
  LIVECASINO_upline_remaining_gt_account_pt: "[真人娱乐场] 上线保留PT（持仓）设置大于账号PT（持仓）设置。",
  LIVECASINO_account_min_gt_p: "[真人娱乐场] 账号最低PT（持仓）设置大于主级PT（持仓）设置。",
  SLOTS_upline_pt_required: "[真人娱乐场] 上线PT（持仓）设置不能为空。",
  SLOTS_pt_setting_exists: "[真人娱乐场] PT（持仓）设置不能为空。",
  SLOTS_parent_pt_not_exists: "[真人娱乐场] 主级PT（持仓）设置不存在。",
  SLOTS_parent_min_not_meet: "[真人娱乐场] 与主级最低PT（持仓）不相符。",
  SLOTS_exceeded_parent_pt: "[真人娱乐场] 超出主级PT（持仓）设置。",
  SLOTS_account_pt_required: "[真人娱乐场] 账号PT（持仓）不能为空。",
  SLOTS_upline_remaining_required: "[真人娱乐场] 上线PT（持仓）设置不能为空。",
  SLOTS_account_min_required: "[真人娱乐场] 账号最低PT（持仓）设置不能为空。",
  SLOTS_upline_remaining_gt_account_pt: "[真人娱乐场] 上线保留PT（持仓）设置大于账号PT（持仓）设置。",
  SLOTS_account_min_gt_pt: "[真人娱乐场] 账号最低PT（持仓）设置大于主级PT（持仓）设置。",
  bet_type_required: "投注类型不能为空。",
  schedule_1_to_7_required: "结算日程不能为空。",
  schedule_exists: "结算日程不存在。",
  parent_schedule_not_exists: "主级结算日程不存在。",
  schedule_1_not_available: "星期一结算不可用。",
  schedule_2_not_available: "星期二结算不可用。",
  schedule_3_not_available: "星期三结算不可用。",
  schedule_4_not_available: "星期四结算不可用。",
  schedule_5_not_available: "星期五结算不可用。",
  schedule_6_not_available: "星期六结算不可用。",
  schedule_7_not_available: "星期日结算不可用。",
  credit_limit_required: "信用额度不能为空。",
  member_credit_limit_required: "会员信用额度不能为空。",
  wallet_exists: "账号已存在。",
  member_credit_limit_gt_credit_limit: "会员信用额度大于信用额度。",
  parent_wallet_not_exists: "账号不存在。",
  account_credit_limit_gt_parent: "账号信用额度大于主级信用额度。",
  member_credit_limit_gt_parent: "会员信用额度大于主级信用额度。",
  exceeded_credit_limit: "超出账号信用额度。",
  soccer_min_bet_required: "最低投注不能为空。",
  soccer_max_bet_required: "最大投注不能为空。",
  soccer_max_per_match_required: "最大单注不能为空。",
  soccer_bet_limit_exists: "投注限额已存在。",
  soccer_parent_bet_limit_not_exists: "主级投注限额不存在。",
  soccer_account_min_bet_lt_parent: "账号最低投注低于主级。",
  soccer_account_max_bet_gt_parent: "账号最大投注大于主级。",
  soccer_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  basketball_max_bet_required: "最大投注不能为空。",
  basketball_max_per_match_required: "最大单注不能为空。",
  basketball_bet_limit_exists: "投注限额已存在。",
  basketball_parent_bet_limit_not_exists: "主级投注限额不存在。",
  basketball_account_min_bet_lt_parent: "账号最低投注低于主级。",
  basketball_account_max_bet_gt_parent: "账号最大投注大于主级。",
  basketball_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  tennis_min_bet_required: "最低投注不能为空。",
  tennis_max_bet_required: "最大投注不能为空。",
  tennis_max_per_match_required: "最大单注不能为空。",
  tennis_bet_limit_exists: "投注限额已存在。",
  tennis_parent_bet_limit_not_exists: "主级投注限额不存在。",
  tennis_account_min_bet_lt_parent: "账号最低投注低于主级。",
  tennis_account_max_bet_gt_parent: "账号最大投注大于主级。",
  tennis_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  baseball_min_bet_required: "最低投注不能为空。",
  baseball_max_bet_required: "最大投注不能为空。",
  baseball_max_per_match_required: "最大单注不能为空。",
  baseball_bet_limit_exists: "投注限额已存在。",
  baseball_parent_bet_limit_not_exists: "主级投注限额不存在。",
  baseball_account_min_bet_lt_parent: "账号最低投注低于主级。",
  baseball_account_max_bet_gt_parent: "账号最大投注大于主级。",
  baseball_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  parlay_min_bet_required: "最低投注不能为空。",
  parlay_max_bet_required: "最大投注不能为空。",
  parlay_max_per_match_required: "最大单注不能为空。",
  parlay_bet_limit_exists: "投注限额已存在。",
  parlay_parent_bet_limit_not_exists: "主级投注限额不存在。",
  parlay_account_min_bet_lt_parent: "账号最低投注低于主级。",
  parlay_account_max_bet_gt_parent: "账号最大投注大于主级。",
  parlay_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  esports_min_bet_required: "最低投注不能为空。",
  esports_max_bet_required: "最大投注不能为空。",
  esports_max_per_match_required: "最大单注不能为空。",
  esports_bet_limit_exists: "投注限额已存在。",
  esports_parent_bet_limit_not_exists: "主级投注限额不存在。",
  esports_account_min_bet_lt_parent: "账号最低投注低于主级。",
  esports_account_max_bet_gt_parent: "账号最大投注大于主级。",
  esports_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  others_min_bet_required: "最低投注不能为空。",
  others_max_bet_required: "最大投注不能为空。",
  others_max_per_match_required: "最大单注不能为空。",
  others_bet_limit_exists: "投注限额已存在。",
  others_parent_bet_limit_not_exists: "主级投注限额不存在。",
  others_account_min_bet_lt_parent: "账号最低投注低于主级。",
  others_account_max_bet_gt_parent: "账号最大投注大于主级。",
  others_account_max_per_match_gt_parent: "账号最大单注大于主级。",
  used_credit_gt_credit_limit: "已使用的信用额度大于信用额度。",
  bet_limit_setting_not_exists: "投注限额设置不存在。",
  parent_bet_limit_setting_not_exists: "主级投注限额设置不存在。",
  package_not_exists_in_parent: "主级投注限额配套设置不存在。",
  soccer_bet_limit_setting_not_exists: "足球投注限额设置不存在。",
  soccer_update_interval_violated: "违反更新间隔。",
  basketball_bet_limit_setting_not_exists: "篮球投注限额设置不存在。",
  basketball_update_interval_violated: "违反更新间隔。",
  tennis_bet_limit_setting_not_exists: "网球投注限额设置不存在。",
  tennis_update_interval_violated: "违反更新间隔。",
  baseball_bet_limit_setting_not_exists: "棒球投注限额设置不存在。",
  baseball_update_interval_violated: "违反更新间隔。",
  parlay_bet_limit_setting_not_exists: "混合过关投注限额设置不存在。",
  parlay_update_interval_violated: "违反更新间隔。",
  esports_bet_limit_setting_not_exists: "电子竞技投注限额设置不存在。",
  esports_update_interval_violated: "违反更新间隔。",
  others_bet_limit_setting_not_exists: "其他投注限额设置不存在。",
  others_update_interval_violated: "违反更新间隔。",
  soccer_parent_bet_limit_setting_not_exists: "足球主级投注限额设置不存在。",
  soccer_min_bet_lt_parent: "足球账号最低投注低于主级。",
  soccer_max_bet_gt_parent: "足球账号最大投注大于主级。",
  soccer_max_per_match_gt_parent: "足球账号最大单注大于主级。",
  basketball_parent_bet_limit_setting_not_exists: "篮球主级投注限额设置不存在。",
  basketball_min_bet_lt_parent: "篮球账号最低投注低于主级。",
  basketball_max_bet_gt_parent: "篮球账号最大投注大于主级。",
  basketball_max_per_match_gt_parent: "篮球账号最大单注大于主级。",
  tennis_parent_bet_limit_setting_not_exists: "网球主级投注限额设置不存在。",
  tennis_min_bet_lt_parent: "网球账号最低投注低于主级。",
  tennis_max_bet_gt_parent: "网球账号最大投注大于主级。",
  tennis_max_per_match_gt_parent: "网球账号最大单注大于主级。",
  baseball_parent_bet_limit_setting_not_exists: "棒球主级投注限额设置不存在。",
  baseball_min_bet_lt_parent: "棒球账号最低投注低于主级。",
  baseball_max_bet_gt_parent: "棒球账号最大投注大于主级。",
  baseball_max_per_match_gt_parent: "棒球账号最大单注大于主级。",
  parlay_parent_bet_limit_setting_not_exists: "混合过关主级投注限额设置不存在。",
  parlay_min_bet_lt_parent: "混合过关账号最低投注低于主级。",
  parlay_max_bet_gt_parent: "混合过关账号最大投注大于主级。",
  parlay_max_per_match_gt_parent: "混合过关账号最大单注大于主级。",
  esports_parent_bet_limit_setting_not_exists: "电子竞技主级投注限额设置不存在。",
  esports_min_bet_lt_parent: "电子竞技账号最低投注低于主级。",
  esports_max_bet_gt_parent: "电子竞技账号最大投注大于主级。",
  esports_max_per_match_gt_parent: "电子竞技账号最大单注大于主级。",
  others_parent_bet_limit_setting_not_exists: "电子竞技主级投注限额设置不存在。",
  others_min_bet_lt_parent: "电子竞技账号最低投注低于主级。",
  others_max_bet_gt_parent: "电子竞技账号最大投注大于主级。",
  others_max_per_match_gt_parent: "电子竞技账号最大单注大于主级。",
  update_interval_violated: "违反更新间隔。",
  exceeded_parent_others: "超出主级其他佣金设置。",
  exceeded_parent_hdp: "超出主级HDP（让球）投注限额设置。",
  soccer_min_bet_gt_max_bet: "最低赌注必须低于或等于最高赌注。",
  soccer_max_bet_gt_max_per_match: "最高赌注必须低于或等于最高每场比赛。",
  basketball_min_bet_gt_max_bet: "最低赌注必须低于或等于最高赌注。",
  basketball_max_bet_gt_max_per_match: "最高赌注必须低于或等于最高每场比赛。",
  tennis_min_bet_gt_max_bet: "最低赌注必须低于或等于最高赌注。",
  tennis_max_bet_gt_max_per_match: "最高赌注必须低于或等于最高每场比赛。",
  baseball_min_bet_gt_max_bet: "最低赌注必须低于或等于最高赌注。",
  baseball_max_bet_gt_max_per_match: "最高赌注必须低于或等于最高每场比赛。",
  parlay_min_bet_gt_max_bet: "最低赌注必须低于或等于最高赌注。",
  parlay_max_bet_gt_max_per_match: "最高赌注必须低于或等于最高每场比赛。",
  esports_min_bet_gt_max_bet: "最低赌注必须低于或等于最高赌注。",
  esports_max_bet_gt_max_per_match: "最高赌注必须低于或等于最高每场比赛。",
  others_min_bet_gt_max_bet: "最低赌注必须低于或等于最高赌注。",
  others_max_bet_gt_max_per_match: "最高赌注必须低于或等于最高每场比赛。",

  validAmount: "Please enter a valid amount",
};
